<template>
  <BasePanel class="filters-panel flex flex-col">
    <BasePanelHeader class="flex justify-between items-center p-4">
      <div />
      <div class="text-sm text-abbey font-semibold select-none">
        Filters
      </div>
      <div>
        <BaseButton @click="onClose">
          <BaseIcon
            class="text-abbey opacity-25 hover:opacity-100"
            name="times"
            height="16"
            width="16"
          />
        </BaseButton>
      </div>
    </BasePanelHeader>

    <div class="content flex-1 overflow-y-auto">
      <slot></slot>
    </div>

    <BasePanelFooter class="flex justify-between py-3 px-4">
      <BaseCheckbox
        class="mr-2 text-xs text-abbey font-normal"
        id="pin-filters"
        :checked="pinFilters"
        @toggle="onTogglePinFilters"
      >
        Pin filters to all reports
      </BaseCheckbox>
      <BaseButton
        class="text-sm text-white bg-deep-cerulean rounded-full"
        @click="onApply"
      >
        Apply
      </BaseButton>
    </BasePanelFooter>
  </BasePanel>
</template>

<script>
export default {
  name: 'FiltersPanel',
  props: {
    pinFilters: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onApply() {
      this.$emit('apply')
    },
    onClose() {
      this.$emit('close')
    },
    onTogglePinFilters() {
      this.$emit('toggle-pin-filters')
    }
  }
}

export { default as FilterItem } from './FilterItem'
</script>

<style>
.filters-panel {
  min-height: 300px;
}
.base-panel-footer .base-button {
  flex: 1;
  max-width: 200px;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>
